// TestContent.js
import React from 'react';

const Inventory = () => {
  return (
    <div>
      <h1>Inventory</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Inventory;
